import React, { useState, useRef, useEffect, useContext } from "react";
import { Bell } from "lucide-react";
import { useNotifications } from "../../context/NotificationContext";
import { ThemeContext } from "../../constant/theme";
import NotificationDropdown from "./NotificationDropdown";
import "./notification.css";

const NotificationBell = ({ isMobile }) => {
  const { unreadCount, fetchNotifications, isDropdownOpen, setIsDropdownOpen, notificationsDisabled } = useNotifications();
  const { theme } = useContext(ThemeContext);
  const bellRef = useRef(null);

  const isDark = theme === "dark";

  const toggleDropdown = async (e) => {
    e.stopPropagation();
    if (!isDropdownOpen) {
      // User is opening the dropdown: trigger a fresh fetch
      await fetchNotifications(1, false);
    }
    setIsDropdownOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDropdownOpen]);

  if (notificationsDisabled) {
    return null;
  }

  // Theme-aware button styles matching the topbar theme toggle button
  const buttonStyle = {
    background: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
    border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.1)"}`,
    borderRadius: isMobile ? "0.75rem" : "0.875rem",
    padding: isMobile ? "0.75rem" : "0.75rem",
    cursor: "pointer",
    color: isDark ? "#ffffff" : "#1f2937",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    backdropFilter: "blur(0.625rem)",
    boxShadow: "0 0.25rem 0.75rem rgba(0, 0, 0, 0.05)",
    position: "relative",
  };

  return (
    <div className="notification-bell-container" ref={bellRef}>
      <button
        className="notification-bell-btn"
        style={buttonStyle}
        onClick={toggleDropdown}
        aria-label="Notifications"
      >
        <Bell size={isMobile ? 18 : 20} />
        {unreadCount > 0 && (
          <span className="notification-badge"></span>
        )}
      </button>

      <NotificationDropdown
        isOpen={isDropdownOpen}
        onClose={() => setIsDropdownOpen(false)}
        isMobile={isMobile}
      />
    </div>
  );
};

export default NotificationBell;
